import script from "./HubPartners.vue?vue&type=script&setup=true&lang=js"
export * from "./HubPartners.vue?vue&type=script&setup=true&lang=js"

import "./HubPartners.vue?vue&type=style&index=0&id=be9cfaa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be9cfaa8"]])

export default __exports__